import axios, { AxiosResponse } from "axios";
import { AccessoryData } from "../@types/accessory";


const BASE_URL = "https://sodastreamapi.azurewebsites.net/accessories";

class AccessoriesClass {
 
  async getAllAccessories(): Promise<{
    data: AccessoryData[] | null;
    error: string | null;
  }> {
    try {
      const response: AxiosResponse<AccessoryData[]> = await axios.get(BASE_URL);
      if (response.status >= 200 && response.status < 300) {
        const accs: AccessoryData[] = response.data;
        
        return { data: accs, error: null };
      } else {
        const error = "Error fetching accessories";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching accessories:", error);
      return { data: null, error };
    }
  }

  async getAccessoryById(
    accessId: number
  ): Promise<{ data: AccessoryData | null; error: string | null }> {
    try {
      const response: AxiosResponse<AccessoryData> = await axios.get(
        `${BASE_URL}/id/${accessId}`
      );
      if (response.status >= 200 && response.status < 300) {
        const product: AccessoryData = response.data;

        return { data: product, error: null };
      } else {
        const error = "Error fetching access by ID";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching access by ID:", error);
      return { data: null, error };
    }
  }

  async getAccessoryByLink(
    accessorylink : string
  ): Promise<{ data: AccessoryData | null; error: string | null }> {
    try {
      const response: AxiosResponse<AccessoryData> = await axios.get(
        `${BASE_URL}/${accessorylink}`
      );
      if (response.status >= 200 && response.status < 300) {
        const accessory: AccessoryData = response.data;

        return { data: accessory, error: null };
      } else {
        const error = "Error fetching accessory by name";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching accessory by name:", error);
      return { data: null, error };
    }
  }
  async createAccessory(
    productData: any
  ): Promise<{ data: AccessoryData | null; error: string | null }> {
    try {
      const response: AxiosResponse<AccessoryData> = await axios.post(
        BASE_URL,
        productData
      );
      if (response.status >= 200 && response.status < 300) {
        const createdProduct: AccessoryData = response.data;

        return { data: createdProduct, error: null };
      } else {
        const error = `Error creating accessory - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error creating accessory:", error.message);

      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }

  async editAcessory(
    productId: number,
    updatedProductData: any
  ): Promise<{ data: AccessoryData | null; error: string | null }> {
    try {
      const response: AxiosResponse<AccessoryData> = await axios.put(
        `${BASE_URL}/id/${productId}`,
        updatedProductData
      );
      if (response.status >= 200 && response.status < 300) {
        const updatedProduct: AccessoryData = response.data;
   
        return { data: updatedProduct, error: null };
      } else {
        const error = `Error updating accessory - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error updating accessory:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }

  async deleteAccessory(
    accessoryId: number
  ): Promise<{ data: AccessoryData | null; error: string | null }> {
    try {
      const response: AxiosResponse<any> = await axios.delete(
        `${BASE_URL}/id/${accessoryId}`
      );

      if (response.status >= 200 && response.status < 300) {

        return { data: response.data, error: null };
      } else {
        const error = `Error deleting Acc - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error deleting acc:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }
}


const productServiceInstance = new AccessoriesClass();
export default productServiceInstance;

